import { createFileRoute, redirect } from "@tanstack/react-router";
import { userInfoQueryOptions } from "@/lib/queries/auth";

export const Route = createFileRoute("/_app/settings_/billing")({
  beforeLoad: async ({ context: { queryClient }, location }) => {
    const user = await queryClient.ensureQueryData(userInfoQueryOptions);
    if (user.user_type === "GUEST" || !user.organization_id) {
      throw redirect({ to: "/" });
    }

    const search = new URLSearchParams(location.searchStr);
    const checkout = search.get("checkout");
    const portal = search.get("portal");
    throw redirect({
      to: "/settings",
      search: {
        tab: "billing",
        checkout: checkout === "success" ? checkout : undefined,
        portal: portal === "return" ? portal : undefined,
      },
      replace: true,
    });
  },
});
